import {SET_ORDER_TYPE_INITIAL} from 'new-constants/ordering-mode.constants';
import {DELIVERY_ADDRESS_POPUP} from 'new-components/popups/delivery-address/DeliveryAddress';
import {OrderingTypes} from 'new-constants/common.constants';
import {SELECT_LOCATION_POPUP} from 'new-components/popups/select-location/SelectLocation';
import {INITIAL_POPUP} from 'new-components/popups/initial/Initial';
import {ZIP_EDIT_POPUP} from 'new-components/popups/zip-edit/ZipEdit';
import {ADD_TO_HOME_SCREEN_POPUP} from "../components/popups/add-to-home-screen/AddToHomeScreen";
import {isRestaurantDineIn, isRestaurantPickup} from "../helpers/restaurant.helper";
import {trackEvent} from "../helpers/tracking.helpers";

function isPossibleToSelectRestaurant(orderType, restaurants) {
	if (orderType === OrderingTypes.delivery) {
		return true;
	}
	if (orderType === OrderingTypes.dineIn && restaurants.filter(r => isRestaurantDineIn(r)).length > 1) {
		return true;
	}
	return orderType === OrderingTypes.pickup && restaurants.filter(r => isRestaurantPickup(r)).length > 1;
}

export const setOrderTypeInitial = (orderType, restaurants = []) => {
	const canSelectRestaurant = isPossibleToSelectRestaurant(orderType, restaurants);
	const popupToShow =
		orderType === OrderingTypes.delivery
			? DELIVERY_ADDRESS_POPUP
			: canSelectRestaurant
				? SELECT_LOCATION_POPUP
				: undefined;

	trackEvent({
		event: 'Select Type',
		properties: {
			'Order Type': orderType
		}
	});

	return {
		type: SET_ORDER_TYPE_INITIAL,
		orderType: orderType,
		showPopup: popupToShow,
		hidePopups: popupToShow
			? [ADD_TO_HOME_SCREEN_POPUP]
			: [SELECT_LOCATION_POPUP, INITIAL_POPUP, DELIVERY_ADDRESS_POPUP, ZIP_EDIT_POPUP, ADD_TO_HOME_SCREEN_POPUP],
	};
};


